import { FC } from 'react';
import TextInput from '../text-input';
import { FormProps } from '../helpers';

interface Props extends FormProps {
  onChange?: (value: string[]) => void;
  value: string | string[];
  onEnter?: (value: string) => void;
  autoComplete?: string;
  placeholder?: string;
  readonly?: boolean;
  maxLength?: number;
}

const ArraySingleInput: FC<Props> = ({ onChange, ...rest }) => {
  const { readonly, value, disabled } = rest;

  const handleChange = (value: string | undefined) => {
    if (readonly || disabled) {
      return;
    }
    onChange && onChange([value || '']);
  };

  const firstValue = Array.isArray(value) ? value[0] : value;

  return <TextInput {...rest} onChange={handleChange} value={firstValue} />;
};

export default ArraySingleInput;
